import { render } from "./MinePage.vue?vue&type=template&id=02239fb3&scoped=true"
import script from "./_MinePage.js?vue&type=script&lang=js"
export * from "./_MinePage.js?vue&type=script&lang=js"

import "./_MinePage.less?vue&type=style&index=0&id=02239fb3&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02239fb3"]])

export default __exports__